import API_BASE_URL from "../config";

export async function getAdvancePayments(orderId, token) {
    const res = await fetch(`${API_BASE_URL}/api/orders/${orderId}/payments`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error("Eroare la preluarea plăților de avans");

    try {
        return await res.json();
    } catch {
        return { payments: [], totalPaid: 0, completionPercent: 0 };
    }
}

export async function addAdvancePayment(orderId, amount, note, token) {
    const res = await fetch(`${API_BASE_URL}/api/orders/${orderId}/payments`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ amount, note }),
    });

    if (!res.ok) {
        const text = await res.text();
        let message = "Eroare la adăugarea plății de avans.";

        try {
            const data = JSON.parse(text);
            message = data.message || data.error || message;
        } catch {
            message = text || message;
        }

        throw new Error(message);
    }

    return res.json();
}

export async function deleteAdvancePayment(paymentId, token) {
    const res = await fetch(`${API_BASE_URL}/api/orders/payments/${paymentId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error("Eroare la ștergerea plății de avans");
    return res.json();
}
